// Labels are native language names, shown as-is regardless of the active UI language.
export const LANGUAGES = [
  { code: "en", label: "English" },
  { code: "es", label: "Español" },
  { code: "pt-BR", label: "Português (Brasil)" },
  { code: "de", label: "Deutsch" },
  { code: "fr", label: "Français" },
  { code: "it", label: "Italiano" },
  { code: "nl", label: "Nederlands" },
  { code: "pl", label: "Polski" },
  { code: "uk", label: "Українська" },
  { code: "ru", label: "Русский" },
];

export const DEFAULT_LANGUAGE = "en";

export const LANGUAGE_STORAGE_KEY = "apily_lang";
